// data/socials.js
export const socials = {
    github: "https://github.com/asherShores5",
    linkedin: "https://www.linkedin.com/in/asher-shores/",
    twitter: "https://twitter.com/yourusername",
    email: "asher.shores5@gmail.com"
  };